export default __webpack_public_path__ + "static/media/secondary.3f5d58d9a8dbd4a2015ea29fec9dee62.svg";